import { render, staticRenderFns } from "./Vitals.vue?vue&type=template&id=4f028b1b"
import script from "./Vitals.vue?vue&type=script&lang=js"
export * from "./Vitals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports